<template>
  <div class="tw-relative">
    <overview-tabs v-model="selectedPeriod" />
    <trends-cards :start-date="startDate" />
    <div class="tw-mb-6 tw-grid tw-grid-cols-9 tw-gap-6 max-xl:tw-grid-cols-1">
      <div v-if="isFeatureAvailable" class="tw-col-span-3 max-xl:tw-col-span-1">
        <incidents-categories :start-date="startDate" tier="msp" />
      </div>

      <div class="tw-col-span-6 max-xl:tw-col-span-1">
        <emails-chart :start-date="startDate" tier="customer" />
      </div>
      <div v-if="isFeatureAvailable"></div>
      <div v-else class="tw-col-span-3 max-xl:tw-col-span-1">
        <targeted-users :start-date="startDate" />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";

import EmailsChart from "@/components/EmailsChart/index.vue";
import TrendsCards from "@/modules/PhishTitan/views/Customer/Overview/TrendsCards/index.vue";
import OverviewTabs from "@/modules/PhishTitan/views/Common/Overview/OverviewPeriodTabs.vue";
import {
  Period,
  getDateFromPeriod,
} from "@/modules/PhishTitan/utils/getDateFromPeriod";
import TargetedUsers from "@/components/TargetedUsers/index.vue";
import { SERVICE_ICON } from "@/utils/services.ts";
import IncidentsCategories from "@/modules/PhishTitan/views/Common/Overview/IncidentsCategories/IncidentsCategories.vue";
import { useFlag } from "@/composables/useFlags/useFlag";
import { usePageMetaStore } from "@/store/pageMeta.store";

const pageMetaStore = usePageMetaStore();
const { t } = useI18n();

pageMetaStore.setPageTitle({ title: t("overview") });

const selectedPeriod = ref<Period>("month");
const startDate = computed(() => getDateFromPeriod(selectedPeriod.value));

const { isFeatureAvailable } = useFlag("INCIDENTS_V3_CATEGORIES");

onMounted(() => {
  pageMetaStore.setPageTitle({
    title: t("email-security-solution"),
    icon: t(SERVICE_ICON.PHISH_SERVICE),
  });
});
</script>
